export const SUPPORTED_CHAINS = ["base", "ethereum", "solana", "robinhood", "bnb", "arc"] as const;

export const CHAIN_LABELS: Record<string, string> = {
  base: "Base",
  ethereum: "Ethereum",
  solana: "Solana",
  robinhood: "Robinhood Chain",
  bnb: "BNB Chain",
  arc: "Arc",
};

const CHAIN_ASSETS: Record<string, string> = {
  base: "/chains/base.svg",
  ethereum: "/chains/ethereum.svg",
  solana: "/chains/solana.svg",
  robinhood: "/chains/robinhood.jpg",
  bnb: "/chains/bnb.svg",
  arc: "/chains/arc.svg",
};

// Decorative only: keep the visible chain name beside the mark.
// Original official assets are preserved; sources are in /chains/Sources.txt.
export default function ChainIcon({
  chain,
  size = 18,
  className = "",
}: {
  chain: string;
  size?: number;
  className?: string;
}) {
  const key = chain.toLowerCase();
  const src = Object.prototype.hasOwnProperty.call(CHAIN_ASSETS, key) ? CHAIN_ASSETS[key] : undefined;
  const classes = `a1-chain-icon inline-block shrink-0 align-middle ${className}`.trim();
  const dimensions = { width: `var(--a1-chain-size, ${size}px)`, height: `var(--a1-chain-size, ${size}px)` };

  return src ? (
    <img
      src={src}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      draggable={false}
      className={classes}
      style={dimensions}
    />
  ) : (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
      className={classes}
      style={dimensions}
    >
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="2" fill="currentColor" stroke="none" />
    </svg>
  );
}
